// Confirming the amount of money the user wants to load onto their wallet using etransfer.
// They are shown the instructions on how to send it and then the money is temporarily loaded
// onto their account.
import React from "react";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import FormLabel from "@material-ui/core/FormLabel";
import Typography from "@material-ui/core/Typography"; // for Material-UI v4

export default function EtransferDialogConfirmation({
  open,
  amount,
  setLoadWalletOpen,
  onClose,
  balance,
  setBalance,
  communityLocation,
  placeOrderOnConfirm,
}) {
  // Checks to see if the user is using a communityLocation or a distributionLocation and checks what the
  // etransfer transaction fees are and then sets them.
  const distributionLocation = communityLocation.pickupLocation
    ? communityLocation.pickupLocation
    : { ...communityLocation };
  const etransferTransactionFee =
    distributionLocation.etransferTransactionFee ?? 0;
  // The e-transfer email set on the distribution location that the user should send payment to.
  const etransferEmail = distributionLocation.etransferEmail;
  // The amount to load onto the wallet with the default being the balance of the order.
  const amountTemp = parseFloat(amount) || 0;

  // If the user wants to go back and change the amount.
  const handleBack = () => {
    setLoadWalletOpen(true);
    onClose(false);
  };
  // The user has confirmed they have sent the etransfer.  When they came here
  // from the "Place Order" flow we also place the order immediately so they
  // don't forget to click "PLACE ORDER" after leaving to send the e-transfer.
  const handleSentMoney = () => {
    const balanceTemp = amountTemp + balance;
    setBalance(balanceTemp);
    onClose(false);
    if (typeof placeOrderOnConfirm === "function") {
      placeOrderOnConfirm();
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose(false)}>
      <DialogTitle>Please send Etransfer Payment</DialogTitle>
      <DialogContent>
        {/* Payment Method */}
        <FormLabel component="legend">
          Loading Money onto Your Account
        </FormLabel>
        <Typography>
          Please send an e-transfer of{" "}
          <strong>${(amountTemp + etransferTransactionFee).toFixed(2)}</strong>{" "}
          (this includes the ${etransferTransactionFee.toFixed(2)} transaction
          fee) to <strong>{etransferEmail}</strong>.
        </Typography>

        <Typography sx={{ mt: 2 }}>
          To help us process your payment more efficiently, please include in
          the memo or notes section of your e-transfer:
        </Typography>

        <ul style={{ marginTop: 8, marginBottom: 8 }}>
          <li>The name on your Farm-to-Plate Marketplace account.</li>
        </ul>

        <Typography sx={{ mt: 2, color: "red" }}>
          Failure to send the e-transfer may result in the cancellation of your
          order.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => handleBack()} color="secondary">
          BACK
        </Button>
        <Button
          onClick={() => handleSentMoney()}
          color="primary"
          variant="contained"
        >
          {typeof placeOrderOnConfirm === "function"
            ? "I'LL SEND THE E-TRANSFER — PLACE ORDER"
            : "I HAVE SENT THE ETRANSFER"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
